export default "__VITE_ASSET__BjpiILZX__"